/* Marobali — menu de tri sur mesure (remplace la liste native du <select>) */
(function () {
	var CHEV = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 4.2l4 4 4-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
	var TICK = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 8.5l3.2 3.2L13 4.8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

	function closeAll(except) {
		document.querySelectorAll('.mb-sort.is-open').forEach(function (w) {
			if (w !== except) { setOpen(w, false); }
		});
	}

	function setOpen(wrap, open) {
		wrap.classList.toggle('is-open', open);
		wrap.querySelector('.mb-sort__btn').setAttribute('aria-expanded', open ? 'true' : 'false');
	}

	function build(sel) {
		if (sel.dataset.mbSort) { return; }
		sel.dataset.mbSort = '1';
		var host = sel.closest('resize-select') || sel;
		host.classList.add('mb-sort-src');

		var wrap = document.createElement('div');
		wrap.className = 'mb-sort';

		var btn = document.createElement('button');
		btn.type = 'button';
		btn.className = 'mb-sort__btn';
		btn.setAttribute('aria-haspopup', 'listbox');
		btn.setAttribute('aria-expanded', 'false');
		btn.innerHTML = '<span class="mb-sort__lab">Trier :</span><span class="mb-sort__val"></span>' + CHEV;

		var list = document.createElement('ul');
		list.className = 'mb-sort__list';
		list.setAttribute('role', 'listbox');
		list.setAttribute('aria-label', 'Trier');

		var opts = [];
		Array.prototype.forEach.call(sel.options, function (o) {
			var li = document.createElement('li');
			li.className = 'mb-sort__opt';
			li.setAttribute('role', 'option');
			li.dataset.value = o.value;
			li.innerHTML = '<span></span>' + TICK;
			li.firstChild.textContent = o.text;
			list.appendChild(li);
			opts.push(li);
		});

		function sync() {
			opts.forEach(function (li) {
				var on = li.dataset.value === sel.value;
				li.setAttribute('aria-selected', on ? 'true' : 'false');
				if (on) { btn.querySelector('.mb-sort__val').textContent = li.firstChild.textContent; }
			});
		}

		function pick(li) {
			if (li.dataset.value !== sel.value) {
				sel.value = li.dataset.value;
				sync();
				sel.dispatchEvent(new Event('input', { bubbles: true }));
				sel.dispatchEvent(new Event('change', { bubbles: true }));
			}
			setOpen(wrap, false);
			btn.focus();
		}

		var focusIdx = -1;
		function focusOpt(i) {
			opts.forEach(function (li) { li.classList.remove('is-focus'); });
			focusIdx = (i + opts.length) % opts.length;
			opts[focusIdx].classList.add('is-focus');
		}

		btn.addEventListener('click', function () {
			var open = !wrap.classList.contains('is-open');
			closeAll(wrap);
			setOpen(wrap, open);
			if (open) {
				var cur = opts.findIndex(function (li) { return li.dataset.value === sel.value; });
				focusOpt(cur < 0 ? 0 : cur);
			}
		});
		btn.addEventListener('keydown', function (e) {
			var open = wrap.classList.contains('is-open');
			if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
				e.preventDefault();
				if (!open) { closeAll(wrap); setOpen(wrap, true); focusOpt(Math.max(focusIdx, 0)); }
				else { focusOpt(focusIdx + (e.key === 'ArrowDown' ? 1 : -1)); }
			} else if ((e.key === 'Enter' || e.key === ' ') && open && focusIdx > -1) {
				e.preventDefault();
				pick(opts[focusIdx]);
			} else if (e.key === 'Escape' && open) {
				setOpen(wrap, false);
			}
		});
		list.addEventListener('click', function (e) {
			var li = e.target.closest('.mb-sort__opt');
			if (li) { pick(li); }
		});

		wrap.appendChild(btn);
		wrap.appendChild(list);
		host.parentNode.insertBefore(wrap, host);
		sync();
	}

	function scan() {
		document.querySelectorAll('select#sort_by, select.orderby').forEach(build);
	}

	document.addEventListener('click', function (e) {
		if (!e.target.closest('.mb-sort')) { closeAll(null); }
	});

	var raf = 0;
	new MutationObserver(function () {
		if (raf) { return; }
		raf = requestAnimationFrame(function () { raf = 0; scan(); });
	}).observe(document.documentElement, { childList: true, subtree: true });

	if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); } else { scan(); }
})();
